"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var helpers_1 = require("../../helpers");
var TextInput_1 = require("../TextInput");
var icons_1 = require("../../icons");
var common_1 = require("../../common");
var EmptyDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: calc(2 * ", " + ", ");\n    height: ", ";\n"], ["\n    width: calc(2 * ", " + ", ");\n    height: ", ";\n"])), helpers_1.SPACING_L, helpers_1.SPACING_XS, helpers_1.SPACING_L);
var Box = styled_components_1.default.section(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    box-sizing: border-box;\n    display: inline-flex;\n    height: ", ";\n"], ["\n    box-sizing: border-box;\n    display: inline-flex;\n    height: ", ";\n"])), helpers_1.SIZE_XXL);
var Pager = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    height: ", ";\n    margin: 0 ", ";\n    padding: 0 ", ";\n\n    font-family: ", ";\n    font-size: ", ";\n\n    display: flex;\n    align-items: center;\n\n    ", "\n"], ["\n    height: ", ";\n    margin: 0 ", ";\n    padding: 0 ", ";\n\n    font-family: ", ";\n    font-size: ", ";\n\n    display: flex;\n    align-items: center;\n\n    ",
    "\n"])), helpers_1.SIZE_L, helpers_1.SPACING_S, helpers_1.SPACING_M, helpers_1.BASE_FONT_FAMILY, helpers_1.FONT_SIZE_M, function (_a) {
    var theme = _a.theme;
    return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        border-left: ", " solid ", ";\n        border-right: ", " solid ", ";\n    "], ["\n        border-left: ", " solid ", ";\n        border-right: ", " solid ", ";\n    "])), helpers_1.BASE_BORDER_WIDTH, theme.colorBorderGrid, helpers_1.BASE_BORDER_WIDTH, theme.colorBorderGrid);
});
var Wrapper = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n\n    ", " + ", " {\n        margin-left: ", ";\n    }\n\n    ", " {\n        color: ", ";\n    }\n"], ["\n    display: flex;\n    align-items: center;\n\n    ", " + ", " {\n        margin-left: ", ";\n    }\n\n    ", " {\n        color: ", ";\n    }\n"])), common_1.PaginationButton, common_1.PaginationButton, helpers_1.SPACING_XS, Pager, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return (disabled ? theme.colorTextLight : theme.colorTextMain);
});
var PagerInput = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    width: ", ";\n    margin: 0 ", ";\n    position: relative;\n\n    [data-text-input='true'] {\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n    }\n"], ["\n    width: ", ";\n    margin: 0 ", ";\n    position: relative;\n\n    [data-text-input='true'] {\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n    }\n"])), function (_a) {
    var strLength = _a.strLength;
    return strLength * 8 + 22 + "px";
}, helpers_1.SPACING_S);
exports.Pagination = helpers_1.createUIElement('Pagination', function (_a, ref) {
    var className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.activePage, activePage = _c === void 0 ? 1 : _c, lastPage = _a.lastPage, _d = _a.hasEnterKeyStopPropagation, hasEnterKeyStopPropagation = _d === void 0 ? true : _d, onPageChange = _a.onPageChange, onPageClick = _a.onPageClick, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "disabled", "activePage", "lastPage", "hasEnterKeyStopPropagation", "onPageChange", "onPageClick", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var inputRef = react_1.useRef(null);
    var _e = helpers_1.useStateValue(activePage, [activePage]), getValue = _e.getValue, setValue = _e.setValue;
    var isNum = new RegExp(/^\d+$/);
    var rewindButtonHandleClick = function () { return !disabled && (onPageClick === null || onPageClick === void 0 ? void 0 : onPageClick(1)); };
    var previousButtonHandleClick = function () {
        return activePage > 1 && !disabled && (onPageClick === null || onPageClick === void 0 ? void 0 : onPageClick(activePage - 1));
    };
    var nextButtonHandleClick = function () {
        return activePage < lastPage && !disabled && (onPageClick === null || onPageClick === void 0 ? void 0 : onPageClick(activePage + 1));
    };
    var forwardButtonHandleClick = function () { return !disabled && (onPageClick === null || onPageClick === void 0 ? void 0 : onPageClick(lastPage)); };
    var changePage = function (value) {
        if (!disabled && value <= lastPage && value > 0) {
            setValue(value);
        }
    };
    var handleBlur = function () {
        var value = getValue();
        if (value === 0) {
            setValue(activePage);
        }
        if (value !== 0 && value !== activePage) {
            changePage(value);
            onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(value);
        }
    };
    var handleChange = function (value) {
        if (!value.length) {
            setValue(0);
        }
        if (value.length && isNum.test(value)) {
            changePage(parseInt(value, 10));
        }
    };
    var value = getValue();
    react_1.useEffect(function () {
        setValue(activePage);
    }, [activePage]);
    return (react_1.default.createElement(Box, __assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: "vm-Pagination " + className, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        react_1.default.createElement(Wrapper, { disabled: disabled },
            activePage <= 1 && react_1.default.createElement(EmptyDiv, null),
            activePage > 1 && (react_1.default.createElement(common_1.PaginationButton, { "data-selector-id": "pagination-rewind-button", onClick: rewindButtonHandleClick, disabled: disabled },
                react_1.default.createElement(icons_1.RewindIcon, null))),
            activePage > 1 && (react_1.default.createElement(common_1.PaginationButton, { "data-selector-id": "pagination-previous-button", onClick: previousButtonHandleClick, disabled: disabled },
                react_1.default.createElement(icons_1.PreviousIcon, null))),
            react_1.default.createElement(Pager, null,
                react_1.default.createElement("span", null, "Page"),
                react_1.default.createElement(PagerInput, { strLength: value.toString().length },
                    react_1.default.createElement("form", { "data-selector-id": "pagination-form", onSubmit: function (e) {
                            var _a;
                            e.preventDefault();
                            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                        } },
                        react_1.default.createElement(TextInput_1.TextInput, { controlRef: inputRef, value: String(value === 0 ? '' : value), onBlur: handleBlur, onChange: handleChange, disabled: disabled, size: common_1.CONTROL_SIZE.full, hasEnterKeyStopPropagation: hasEnterKeyStopPropagation }))),
                react_1.default.createElement("span", null,
                    "of ",
                    lastPage)),
            activePage < lastPage && (react_1.default.createElement(common_1.PaginationButton, { "data-selector-id": "pagination-next-button", onClick: nextButtonHandleClick, disabled: disabled },
                react_1.default.createElement(icons_1.NextIcon, null))),
            activePage < lastPage && (react_1.default.createElement(common_1.PaginationButton, { "data-selector-id": "pagination-forward-button", onClick: forwardButtonHandleClick, disabled: disabled },
                react_1.default.createElement(icons_1.ForwardIcon, null))),
            activePage >= lastPage && react_1.default.createElement(EmptyDiv, null))));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=Pagination.js.map